import React from "react";
import { Link } from "react-router-dom";
import { Container, Card, Row, Col, Form } from "react-bootstrap";
import * as yup from "yup";
import { Formik } from "formik";

import { auth, useUser } from "../firebase";
import Logo from "../Logo.svg";
import LoadingButton from "../components/LoadingButton";
import FormTextbox from "../components/FormTextbox";
import { KVIS_SIGNIN_REDIRECT } from "../firebase/UserContext";

const validationSchema = yup.object().shape({
  email: yup
    .string()
    .email("Email is invalid")
    .required("Email is required"),
  password: yup.string().required("Password is required")
});


const handleLogin = async (values, actions) => {
  try {
    await auth().signInWithEmailAndPassword(values.email, values.password);
  } catch(error) {
    switch (error.code) {
      case "auth/invalid-email":
      case "auth/user-disabled":
      case "auth/user-not-found":
        actions.setFieldError("email", error.message);
        break;
      case "auth/wrong-password":
        actions.setFieldError("password", error.message);
        break;
      default:
    }
    actions.setSubmitting(false);
  }
};


const Login = ({ location }) => {
  const { signInWithKvis, isSignInPending } = useUser();

  const handleSignInWithKvis = () => {
    signInWithKvis();
  };

  if (isSignInPending()) return (
    <Container>
      <Row className="justify-content-center mt-4">
        <Col md="4">
          <Card className="p-4">
            Please wait while redirecting...
          </Card>
        </Col>
      </Row>
    </Container>
  );

  const redirect = window.sessionStorage.getItem(KVIS_SIGNIN_REDIRECT);

  return (
    <Container>
      <Row className="justify-content-center mt-4">
        <Col md="4">
          <Card className="p-4 mb-4">
            <>
              {redirect && (
                <div className="alert alert-danger">{`You need to be logged in to view: ${
                  redirect
                }`}</div>
              )}
              <div className="text-center mb-4">
                <Link to="/">
                  <img src={Logo} alt="Logo" height="22" />
                </Link>
              </div>
              <LoadingButton onClick={handleSignInWithKvis}>Login with KVIS</LoadingButton>
            </>
          </Card>
          <Card className="p-4">
            <h3 className="mb-4">Legacy User</h3>
            <React.Fragment>
              <Formik
                initialValues={{
                  email: "",
                  password: ""
                }}
                validationSchema={validationSchema}
                onSubmit={handleLogin}
              >
                {formik => (
                  <Form noValidate onSubmit={formik.handleSubmit}>
                    <FormTextbox formik={formik} controlId="email" label="KVIS Email" />
                    <FormTextbox formik={formik} controlId="password" label="Password" password />
                    <LoadingButton
                      isLoading={formik.isSubmitting}
                      variant="primary"
                      type="submit"
                      className="w-100"
                    >
                      Login
                    </LoadingButton>
                  </Form>
                )}
              </Formik>
              <div className="mt-4">
                <div>
                Forgot password? <Link to="/forgot">Reset Password</Link>
                </div>
              </div>
            </React.Fragment>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
